import { AxiosError } from 'axios';
import { createTrainingToolsParams } from '../interface/interface';
import instance from '../config/axios';

export const createTrainingToolProfile = async (
  token: string,
  params: createTrainingToolsParams,
) => {
  try {
    const fd = new FormData();
    fd.append('name', params.name);
    fd.append('file', params.file);

    const response = await instance({
      method: 'POST',
      url: '/api/v1/create/training-tools',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
        'File-type': params.type,
      },
      data: fd,
    });

    return response.status;
  } catch (e) {
    return ((e as AxiosError).response?.data as { message: string }).message;
  }
};
